"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightPassengerFilter = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const Button_1 = require("../../../Button");
const Remove_1 = require("../../../Button/Remove");
const CheckBox_1 = require("../../../CheckBox");
const Field_1 = require("../../../Form/Field");
const Wrapper_1 = require("../../../Form/Field/Wrapper");
const Icon_1 = require("../../../Icon");
const MultiLanguage_1 = require("../../../MultiLanguage");
const messages_1 = require("./messages");
require("./index.scss");
const className = 'flight-passenger-filter';
class FlightPassengerFilterClass extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            form: this.props.form,
        };
        this.resetForm = () => {
            this.props.onReset();
        };
        this.changeForm = () => {
            if (!this.props.isSubmitButtonDisable) {
                const { reservationId, searchText, appearingStatuses, paymentStatuses, tariffGroups, } = this.state.form;
                this.props.onChange({
                    reservationId,
                    searchText,
                    appearingStatuses,
                    paymentStatuses,
                    tariffGroups,
                });
            }
        };
        this.submitForm = () => {
            this.props.onSubmit();
        };
        this.handleSearchTextChange = (event) => {
            const { value } = event.target;
            this.setState({ form: { ...this.state.form, searchText: value } }, this.changeForm);
        };
        this.handleAppearingStatusChange = (event) => {
            var _a, _b;
            const name = event.target.name;
            const appearingStatuses = ((_a = this.state.form.appearingStatuses) === null || _a === void 0 ? void 0 : _a.includes(name))
                ? this.state.form.appearingStatuses.filter(status => status !== name)
                : [...(_b = this.state.form.appearingStatuses) !== null && _b !== void 0 ? _b : [], name];
            this.setState({ form: { ...this.state.form, appearingStatuses } }, this.changeForm);
        };
        this.handlePaymentStatusChange = (event) => {
            var _a, _b;
            const name = event.target.name;
            const paymentStatuses = ((_a = this.state.form.paymentStatuses) === null || _a === void 0 ? void 0 : _a.includes(name))
                ? this.state.form.paymentStatuses.filter(status => status !== name)
                : [...(_b = this.state.form.paymentStatuses) !== null && _b !== void 0 ? _b : [], name];
            this.setState({ form: { ...this.state.form, paymentStatuses } }, this.changeForm);
        };
        this.handleTariffGroupChange = (event) => {
            var _a, _b;
            const { name } = event.target;
            const id = Number(name);
            const tariffGroups = ((_a = this.state.form.tariffGroups) === null || _a === void 0 ? void 0 : _a.includes(id))
                ? this.state.form.tariffGroups.filter(tariffGroupId => tariffGroupId !== id)
                : [...(_b = this.state.form.tariffGroups) !== null && _b !== void 0 ? _b : [], id];
            this.setState({ form: { ...this.state.form, tariffGroups } }, this.changeForm);
        };
        this.handleRemoveReservationFilter = () => {
            this.setState({ form: { ...this.state.form, reservationId: undefined } }, this.changeForm);
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.form && prevProps.form !== this.props.form) {
            this.setState({ form: this.props.form });
        }
    }
    render() {
        var _a;
        const { info, modificators } = this.props;
        const pending = info.reduce((total, countsByTariffGroup) => total + countsByTariffGroup.pending, 0);
        const appeared = info.reduce((total, countsByTariffGroup) => total + countsByTariffGroup.appeared, 0);
        const notAppeared = info.reduce((total, countsByTariffGroup) => total + countsByTariffGroup.notAppeared, 0);
        const paid = info.reduce((total, countsByTariffGroup) => total + countsByTariffGroup.paid, 0);
        const notPaid = info.reduce((total, countsByTariffGroup) => total + countsByTariffGroup.notPaid, 0);
        const mapTariffGroups = (tariffGroup) => {
            var _a;
            const totalByTariffGroup = (_a = info
                .filter(countsByTariffGroup => countsByTariffGroup.tariffGroup.id === tariffGroup.id)
                .map(countsByTariffGroup => countsByTariffGroup.total).pop()) !== null && _a !== void 0 ? _a : 0;
            return (react_1.default.createElement(CheckBox_1.CheckBox, { key: tariffGroup.id, text: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(MultiLanguage_1.MultiLanguage, { value: tariffGroup.name }),
                    " (",
                    totalByTariffGroup,
                    ")"), name: `${tariffGroup.id}`, modificators: ['inline'], onChange: this.handleTariffGroupChange, checked: tariffGroups === null || tariffGroups === void 0 ? void 0 : tariffGroups.includes(tariffGroup.id) }));
        };
        const { reservationId, searchText, appearingStatuses, paymentStatuses, tariffGroups, } = this.state.form;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__form` },
                react_1.default.createElement("div", { className: `${className}__search` },
                    react_1.default.createElement("div", { className: `${className}__icon` },
                        react_1.default.createElement(Icon_1.Icon, { name: 'search' })),
                    react_1.default.createElement(Field_1.FormField, { placeholder: this.props.intl.formatMessage(messages_1.messages.searchPlaceholder), onChange: this.handleSearchTextChange, value: searchText !== null && searchText !== void 0 ? searchText : '', modificators: ['search'] })),
                react_1.default.createElement("div", { className: `${className}__button` },
                    react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/Filter:SearchButton', defaultMessage: 'Search' }), modificators: ['ascetic', 'block'], onClick: this.submitForm }))),
            react_1.default.createElement("div", { className: `${className}__form` },
                react_1.default.createElement("div", { className: `${className}__checkboxes` },
                    react_1.default.createElement("div", { className: `${className}__status-checkboxes` },
                        react_1.default.createElement("div", { className: `${className}__checkboxes-title` },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/Filter:StatusTitle', defaultMessage: 'Status:' })),
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/Filter:StatusPending', defaultMessage: 'Pending' }),
                                " ",
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    "(",
                                    pending,
                                    ")")), name: 'pending', modificators: ['inline'], onChange: this.handleAppearingStatusChange, checked: (appearingStatuses === null || appearingStatuses === void 0 ? void 0 : appearingStatuses.includes('pending')) || false }),
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/Filter:StatusAppeared', defaultMessage: 'Appeared' }),
                                " ",
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    "(",
                                    appeared,
                                    ")")), name: 'appeared', modificators: ['inline'], onChange: this.handleAppearingStatusChange, checked: (appearingStatuses === null || appearingStatuses === void 0 ? void 0 : appearingStatuses.includes('appeared')) || false }),
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/Filter:StatusNoShow', defaultMessage: 'No-Show' }),
                                " ",
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    "(",
                                    notAppeared,
                                    ")")), name: 'not-appeared', modificators: ['inline'], onChange: this.handleAppearingStatusChange, checked: (appearingStatuses === null || appearingStatuses === void 0 ? void 0 : appearingStatuses.includes('not-appeared')) || false })),
                    react_1.default.createElement("div", { className: `${className}__payment-checkboxes` },
                        react_1.default.createElement("div", { className: `${className}__checkboxes-title` },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/Filter:PaymentTitle', defaultMessage: 'Payment:' })),
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/Filter:PaymentPaid', defaultMessage: 'Paid' }),
                                " ",
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    "(",
                                    paid,
                                    ")")), name: 'paid', modificators: ['inline'], onChange: this.handlePaymentStatusChange, checked: (paymentStatuses === null || paymentStatuses === void 0 ? void 0 : paymentStatuses.includes('paid')) || false }),
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/Filter:PaymentUnpaid', defaultMessage: 'Unpaid' }),
                                " ",
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    "(",
                                    notPaid,
                                    ")")), name: 'not-paid', modificators: ['inline'], onChange: this.handlePaymentStatusChange, checked: (paymentStatuses === null || paymentStatuses === void 0 ? void 0 : paymentStatuses.includes('not-paid')) || false })),
                    react_1.default.createElement("div", { className: `${className}__class-checkboxes` },
                        react_1.default.createElement("div", { className: `${className}__checkboxes-title` },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/Filter:ClassTitle', defaultMessage: 'Class:' })), (_a = this.props.tariffGroups) === null || _a === void 0 ? void 0 :
                        _a.map(mapTariffGroups))),
                react_1.default.createElement("div", { className: `${className}__reset` },
                    react_1.default.createElement(Button_1.Button, { icon: 'cycle', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:ResetButton', defaultMessage: 'Reset' }), onClick: this.resetForm, modificators: ['simple', 'block'] }))),
            react_1.default.createElement("div", { className: `${className}__form` }, reservationId && (react_1.default.createElement("div", { className: `${className}__reset-reservation` },
                react_1.default.createElement(Wrapper_1.FormFieldWrapper, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:ReservationLabel', defaultMessage: 'Reservation' }), slot: react_1.default.createElement("div", { className: `${className}__reservation` },
                        react_1.default.createElement("div", { className: `${className}__reservation-name` }, reservationId),
                        react_1.default.createElement(Remove_1.RemoveButton, { text: '', right: true, onClick: this.handleRemoveReservationFilter })) }))))));
    }
}
FlightPassengerFilterClass.defaultProps = {
    form: {
        reservationId: undefined,
        searchText: '',
        appearingStatuses: [],
        paymentStatuses: [],
        tariffGroups: [],
    },
    onSubmit: () => { },
    onReset: () => { },
    tariffGroups: [],
    isSubmitButtonDisable: false,
    info: [],
};
exports.FlightPassengerFilter = (0, react_intl_1.injectIntl)(FlightPassengerFilterClass);
//# sourceMappingURL=index.js.map